import {
  jsx as jsx,
  jsxs as jsxs,
} from 'react/jsx-runtime';
import { buildChildren1tjqe2lljx0v as buildChildren } from '../../ChildrenBuilder.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { asNodeArrayOrNull1w9l3ncxhchp6 as asNodeArrayOrNull } from '../../ReactNode.mjs';
import { singleOrNull28acamgsnmzwe as singleOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function jsx_0(type, props) {
  return jsx_1(type, props, null);
}
function jsx_1(type, props, defaultKey) {
  if (props == null) {
    var tmp = jsx;
    // Inline function 'js.objects.unsafeJso' call
    var tmp_0 = {};
    return tmp(type, tmp_0, defaultKey == null ? undefined : defaultKey);
  }
  var finalProps = props;
  var tmp1_elvis_lhs = props.key;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? defaultKey : tmp1_elvis_lhs;
  var finalKey = tmp2_elvis_lhs == null ? undefined : tmp2_elvis_lhs;
  var builderChildren = buildChildren(props);
  var jsxMode = true;
  if (!(props.key === undefined) || !(builderChildren == null)) {
    var tmp_1 = Object;
    // Inline function 'js.objects.unsafeJso' call
    var tmp$ret$1 = {};
    finalProps = tmp_1.assign(tmp$ret$1, props);
    Reflect.deleteProperty(finalProps, 'key');
    if (!(builderChildren == null)) {
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var container = finalProps;
      if (!(container.children == null)) {
        reportError(IllegalStateException().o('Both `children` source options used. Prop `children` will be ignored.'));
      }
      var tmp3_safe_receiver = asNodeArrayOrNull(builderChildren);
      var singleBuilderChild = tmp3_safe_receiver == null ? null : singleOrNull(tmp3_safe_receiver);
      jsxMode = !(singleBuilderChild == null);
      container.children = singleBuilderChild == null ? builderChildren : singleBuilderChild;
    }
  }
  var create = jsxMode ? jsx : jsxs;
  return create(type, finalProps, finalKey);
}
function jsx_2(type) {
  var tmp = jsx;
  // Inline function 'js.objects.unsafeJso' call
  return tmp(type, {});
}
//region block: exports
export {
  jsx_1 as jsx2uf3lx2x6pvok,
  jsx_0 as jsx32bqjs36pyex9,
  jsx_2 as jsx3d877eni2yh4i,
};
//endregion

//# sourceMappingURL=jsx.mjs.map
